import { X } from "lucide-react";
import { useLang } from "../i18n";
import { Reveal } from "./Reveal";

export const Stakes = () => {
  const { t } = useLang();
  const s = t.stakes;

  return (
    <section id="stakes" className="relative py-24 lg:py-32">
      <div
        className="absolute inset-0 pointer-events-none"
        style={{ background: "radial-gradient(800px 500px at 85% 15%, rgba(0,75,147,0.25), transparent 60%)" }}
      />
      <div className="relative mx-auto max-w-7xl px-4 sm:px-6 grid lg:grid-cols-12 gap-12 items-start">
        <div className="lg:col-span-6">
          <Reveal>
            <p className="mono-label">{s.eyebrow}</p>
            <h2 className="mt-4 font-display uppercase font-bold tracking-tight leading-[0.98] text-3xl sm:text-4xl lg:text-5xl">
              {s.empathy}
            </h2>
            <p className="mt-6 text-lg text-txt leading-relaxed">{s.sub}</p>
            <p className="mt-5 text-txt-2 leading-relaxed">{s.lead2}</p>
            <p className="mt-5 text-txt font-medium" data-testid="stakes-risk">{s.risk}</p>
          </Reveal>
          <Reveal delay={0.15} className="mt-9 border-l-2 border-hadron-green pl-6">
            <p className="text-lg lg:text-xl text-txt leading-relaxed" data-testid="stakes-philosophy">“{s.philosophy}”</p>
          </Reveal>
        </div>
        <div className="lg:col-span-6 grid sm:grid-cols-2 gap-4">
          {s.items.map((item, i) => (
            <Reveal key={i} delay={i * 0.07} className="card-surface p-5 flex items-start gap-3">
              <X size={16} className="mt-0.5 shrink-0 text-rose-400/80" />
              <p className="text-sm text-txt-2 leading-relaxed" data-testid={`stakes-item-${i}`}>{item}</p>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
